export function getSidebarContainerVisible(id: string): boolean {
  const value = localStorage.getItem(`sidebarContainerVisible_${id}`);

  if (value) {
    return value === 'true';
  }

  return false;
}

export function setSidebarContainerVisible(id: string, value: boolean): void {
  localStorage.setItem(`sidebarContainerVisible_${id}`, value ? 'true' : 'false');
}
